export default "__VITE_ASSET__Q707k$qA__"